import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import TextArea from './Utils/textarea.js'

import landingpage_sectionone1 from './Assets/landingpage/sectionone1.png';
import configData from './Config.json';
import Metatags from './Metatags.js';
import Select from './Utils/select.js';

import landingpage_facebookicon from './Assets/landingpage/facebookicon.png';
import landingpage_linkedinicon from './Assets/landingpage/linkedinicon.png';
import landingpage_instagramicon from './Assets/landingpage/instagramicon.png';
import landingpage_emailicon from './Assets/landingpage/emailicon.png';
import landingpage_whatsappicon from './Assets/landingpage/whatsappicon.png';
import landingpage_appstore from './Assets/landingpage/appstore.png';
import landingpage_playstore from './Assets/landingpage/playstore.png';

import './LandingPage.css';

function LandingPage({ state, setState }) {

    const history = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleCountry = (country) => {
        setState(state => ({
            ...state,
            selectedcountry: country.id,
            selecteddistrict: country.defaultdistrict,
            selectedcommunity: 0,
            selectedoffset: 0,
            selectedagreement: 0,
            selectedtype: 0
        }))
        history('/' + country.dir)
    }

    const handleWhatsapp = (text) => {
        const phoneNumber = "+96170617919";
        const encodedText = encodeURIComponent(text);
        const url = `https://wa.me/${phoneNumber}?text=${encodedText}`;

        window.open(url, "_blank", "noopener,noreferrer");
    }

    const handleMessage = (message) => {
        setState(state => ({ ...state, modalopen: true, modalcontent: <AppStore state={state} setState={setState} message={message} />, modaltype: 'small', modaltitle: 'App Store' }))
    }

    function PropertyRequest() {
        const [country, setCountry] = useState("");
        const [district, setDistrict] = useState("");
        const [type, setType] = useState("");
        const [agreement, setAgreement] = useState(false);
        const [description, setDescription] = useState("");

        const [loading, setLoading] = useState(false);
        const [result, setResult] = useState('');

        const [districts, setDistricts] = useState([]);
        const [types, setTypes] = useState([]);

        const handleSubmit = async (e) => {
            e.preventDefault();

            handleMessage('Under development.')
            if (loading) return;

            setLoading(true);
            setResult("");

            const data = {
                countryid: country,
                districtid: district,
                typeid: type,
                description: description
            };
            console.log(data)
            return

            try {
                const res = await axios.post(configData.SECUREURL + configData.ADDPROPERTYREQUEST, data, {
                    headers: {
                        "Accept": "application/json",
                        "Content-Type": "application/json;charset=UTF-8"
                    },
                });

                setResult("Your property request has been submitted successfully!");
            } catch (err) {
                console.log(err.response?.data?.message || err.message || 'Network error');
                setResult("Failed to submit property request. Please try again.");
            } finally {
                setTimeout(() => {
                    setLoading(false);
                }, 3000);
            }
        };

        return (
            <div id="propertyrequest" className="landingpage_section">
                <div className="landingpage_sectioncontainer">

                    <p className="landingpage_sectiontitle">Property Request</p>
                    <h2 className="landingpage_sectionheader">Find Your Ideal Property</h2>
                    <p className="landingpage_sectiondescription">
                        Submit your requirements below and our team will get in touch with tailored property matches for you.
                    </p>

                    <form onSubmit={handleSubmit} className='landingpage_requestform'>

                        <div className="row">
                            <Select
                                data={state?.countries || []}
                                itemid={country}
                                setItemid={setCountry}
                                label="Country"
                            />
                        </div>

                        <div className="row">
                            <Select
                                data={districts}
                                itemid={setDistricts}
                                setItemid={setDistrict}
                                label="District"
                            />
                        </div>

                        <div className="row">
                            <Select
                                data={types}
                                itemid={type}
                                setItemid={setType}
                                label="Property Type"
                            />
                        </div>

                        <div className="row">
                            <TextArea
                                value={description}
                                setValue={setDescription}
                                label="Property Request"
                                placeholder='I want an apartment in XXX for Sale at a price of $$$'
                            />
                        </div>

                        {result && (
                            <p style={{ marginTop: "12px", fontSize: "14px", color: agreement ? "green" : "red" }}>
                                {result}
                            </p>
                        )}
                        <div className="row">
                            <button
                                type="submit"
                                className='landingpage_requestformbutton'
                            >
                                Send Request
                            </button>
                        </div>
                    </form>

                </div>
            </div>
        );
    }

    function AppStore({ message }) {
        const handleCloseAppStore = () => {
            setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_message'>{message}</div>
                        </div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className='modal_button' onClick={handleCloseAppStore}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    function PlayStore() {
        const handleClosePlayStore = () => {
            setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
        }

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_message'>App still under development. Will be released soon.</div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className='modal_button' onClick={handleClosePlayStore}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className='countries'>
            <Metatags
                title='SoukAkarat.com | Online real estate listings'
                description="SoukAkarat.com has listings for properties. Place a free ad. Find what you're looking for now!"
                keywords='buy, sell, rent, properties, arab countries, شراء, بيع, إيجار, عقارات, البلاد العربية'
                canonical={configData.SECUREURL}
                robots='index'
                image={configData.SECUREURL + '/' + configData.SEOIMAGE}
            />

            <div className='landingpage_section'>
                <div className='landingpage_sectioncontainer'>
                    <h1 className='landingpage_sectionheader'>Search Properties</h1>
                    <h1 className='landingpage_sectiondescription'>Electronic Real Estate platform in the Arab World</h1>
                </div>
            </div>

            <div className='landingpage_section'>
                <div className='landingpage_sectioncontainer'>
                    {
                        state.countries.map((country, index) =>
                            <div key={'country' + index} className='landingpage_countrybutton' onClick={() => handleCountry(country)} >
                                <h3 className='landingpage_countrybuttontext'>{country.name} ({country.count})</h3>
                            </div>
                        )
                    }
                </div>
            </div>

            <div className='landingpage_section'>
                <div className='landingpage_sectioncontainer'>

                    <h2 className="landingpage_sectionheader">Online real estate listings network</h2>
                    <p className='landingpage_sectiondescription'>SoukAkarat is a comprehensive online real estate listings network that simplifies the process of finding a property. Our platform allows users to browse and search for properties with ease, making it easier than ever to find the perfect home or investment opportunity. What sets us apart is that we offer these services completely online and at no cost to our users. Whether you're a buyer, seller, or landlord, SoukAkarat has the resources you need to navigate the real estate market with confidence. <span className='landingpage_sectiontwohashtags'>#realEstate</span>  <span className='landingpage_sectiontwohashtags'>#listings</span>  <span className='landingpage_sectiontwohashtags'>#properties</span></p>

                    <h2 className="landingpage_sectionheader">Disclaimer</h2>

                    <p className='landingpage_sectiondescription'>It is important for users to exercise due diligence and verify the authenticity of any property they are interested in. This may include conducting thorough inspections, obtaining professional advice, and verifying ownership and legal documentation.</p>
                    <p className='landingpage_sectiondescriptionarabic'>يجب على المستخدمين ممارسة العناية الواجبة والتحقق من صحة أي عقار يهتمون به. وقد يشمل ذلك إجراء عملية تدقيق والتحقق من الملكية والوثائق القانونية.</p>

                </div>
            </div>

            <PropertyRequest />

            <section id="apps" className="landingpage_section">
                <div className="landingpage_sectioncontainer">

                    <p className="landingpage_sectiontitle">Apps</p>
                    <h2 className="landingpage_sectionheader">Souk Akarat CRM & Business Operations</h2>
                    <p className="landingpage_sectiondescription">
                        Empower your real estate operations with our all-in-one mobile CRM platform. Manage client leads, track property listings, process instant notifications, and streamline communication seamlessly across the region.
                    </p>

                    <div className="landingpage_onecontainer">
                        <button
                            type="button"
                            className="landingpage_button landingpage_buttonblack"
                            onClick={() => handleMessage('App still under development. Will be released soon.')}
                            title="Play Store"
                        >
                            <img className="landingpage_appimage" src={landingpage_playstore} alt="Play Store" />
                        </button>

                        <button
                            type="button"
                            className="landingpage_button landingpage_buttonblack"
                            onClick={() => handleMessage('App still under development. Will be released soon.')}
                            title="App Store"
                        >
                            <img className="landingpage_appimage" src={landingpage_appstore} alt="App Store" />
                        </button>
                    </div>
                </div>
            </section>

            <footer className="landingpage_footer">
                <div className="landingpage_footercontainer">
                    <div className="landingpage_footerbrand">
                        <p className="landingpage_footername">SOUK AKARAT</p>
                        <p className="landingpage_footertagline">ONLINE REAL ESTATE LISTINGS</p>
                    </div>

                    <div className="landingpage_socialicons">
                        <a className="landingpage_footersocialiconcontainer" href={configData.FACEBOOKLINK} target="_blank" rel="noopener noreferrer" title="Facebook">
                            <img className='landingpage_footersocialicon' src={landingpage_facebookicon} alt="Facebook Icon" />
                        </a>
                        <a className="landingpage_footersocialiconcontainer" href={configData.LINKEDINLINK} target="_blank" rel="noopener noreferrer" title="LinkedIn">
                            <img className='landingpage_footersocialicon' src={landingpage_linkedinicon} alt="LinkedIn Icon" />
                        </a>
                        <a className="landingpage_footersocialiconcontainer" href={configData.INSTAGRAMLINK} target="_blank" rel="noopener noreferrer" title="Instagram">
                            <img className='landingpage_footersocialicon' src={landingpage_instagramicon} alt="Instagram Icon" />
                        </a>
                        <a className="landingpage_footersocialiconcontainer" href={configData.EMAILLINK} title="Email">
                            <img className='landingpage_footersocialicon' src={landingpage_emailicon} alt="Email Icon" />
                        </a>
                        <a className="landingpage_footersocialiconcontainer" onClick={() => handleWhatsapp('')} target="_blank" rel="noopener noreferrer" title="WhatsApp">
                            <img className='landingpage_footersocialicon' src={landingpage_whatsappicon} alt="Whatsapp Icon" />
                        </a>
                    </div>

                    <div className='landingpage_footerLinkContainer'>
                        <Link className='landingpage_footerLink' to='privacypolicy'>Privacy Policy</Link>
                    </div>
                    <p className="landingpage_footercopyright">© 2026 PROPERTY DYNAMICS. ALL RIGHTS RESERVED.</p>
                </div>
            </footer>
        </div>
    )
}

export default LandingPage;